import { observable, computed, action } from "mobx";
import { PATH_MENU_PRINCIPALE_PEGNO, PATH_MENU_PRINCIPALE_UNIMOD,PATH_MENU_PRINCIPALE_PEGNO_CERT, PATH_MENU_PRINCIPALE_CI } from '../config/presdoc-fe-config'


class MenuStore {

  constructor(root) {   
    this.rootStore = root;
    this.service = root.service
  }

  @observable config = {
    fromPegni: false,
    fromUnimodweb: false,
    fromPegniCert: false
  }

  @observable menuItems = [];
  
  
  @action
  async isMenuItemPresent(itemName) {
  
    console.log(JSON.stringify(this.menuItems))
    console.log(this.menuItems.some(item => item.etichetta === itemName))
    return this.menuItems.some(item => item.etichetta === itemName);
  }
  @observable
   @action
   async fetchMenuItems() {   
     let url = '';
     let localContext = process.env.CONTEXT_PATH;
     let remoteContext = '';
     if (this.config.fromPegni) {
      url = `${PATH_MENU_PRINCIPALE_PEGNO}`;
      remoteContext = process.env.CONTEXT_PEGNI;
     }
     if (this.config.fromUnimodweb) {
      url = `${PATH_MENU_PRINCIPALE_UNIMOD}${this.rootStore.qualificheStore.qualifica.identificativoProfilo}`;
      remoteContext = process.env.CONTEXT_UNIMOD;
     }
     if (this.config.fromPegniCert) {
      url = `${PATH_MENU_PRINCIPALE_PEGNO_CERT}`;
      remoteContext = process.env.CONTEXT_PEGNO_CERT;
     }
     if (this.config.fromCancellazioni) {
      url = `${PATH_MENU_PRINCIPALE_CI}`;
      remoteContext = process.env.CONTEXT_CI;
     }
     // se l'url non e' configurato, non viene scatenata alcuna chiamata al backend poiche' non e' ancora identificato il tipo di applicazione
     if (!url) {
       return;
     }

     await this.service.doAjax('POST', url,
      {
        //identificativoUtente: LZZMRC80E09H501N,
        identificativoReferente: this.rootStore.qualificheStore.qualifica.collaborazioni[0].identificativoReferente,
        identificativoUtenza: this.rootStore.qualificheStore.qualifica.identificativoUtenza,
        //codServizio:PDI01
      }
     ).then(response => {    
        if(response.success) {
         const items = response.result.map((voce,index)=>{
            return {
              exact: voce.flagExact == "1",
              label: voce.etichetta,
              //path: `${voce.flagLocale == 1 ? localContext : remoteContext }${voce.path}`,
              path: `${voce.flagLocale == 1 ? localContext : '' }${voce.path}`,
              icon: voce.icona ? voce.icona : undefined,
              //remote: voce.flagLocale == 0
              remote: false
            }
          })
          //console.log(this.qualificheStore.qualifiche)
          if(this.rootStore.qualificheStore.qualifiche.length> 1){
            items.push( {
            exact: false,
            label: "Cambia profilo invio",
            path: "/PresdocWEB/qualifiche",
            icon: "fas fa-user",
            
          })
        }       
        this.menuItems.replace(items);    
        }
    })
    
    console.log( JSON.stringify(this.menuItems) + "this.menuItems")
  }


   @action
   configureFromPegni() {
    this.config = {
      fromPegni: true,
      fromUnimodweb: false
    }
    this.fetchMenuItems();
   }
   

   @action
   configureFromUnimodweb() {
    this.config = {
      fromPegni: false,
      fromUnimodweb: true,
      fromPegniCert:false,
      fromCancellazioni:false,
    }
    this.fetchMenuItems();
   }
   
   @action
   configureFromPegniCertificati() {
    this.config = {
      fromPegni: false,
      fromUnimodweb: false,
      fromPegniCert:true,
      fromCancellazioni:false,
    }
    this.fetchMenuItems();
   }
   
   @action
   configureFromCancellazioniIpoteca() {
    this.config = {
      fromPegni: false,
      fromUnimodweb: false, 
      fromPegniCert:false,
      fromCancellazioni:true,
    }
    this.fetchMenuItems();
   }

  

}

export default MenuStore;